import PropTypes from 'prop-types'
import styles from './style.module.scss'
import CustomLink from '@shared/components/customLink'

const WidgetCardHeader = ({ headerText, link, internalLink = false }) => {
  return (
    <div className={styles.cardContainer}>
      <div className={styles.header}>
        <p className={`mb-0 ${styles.header_text}`}>{headerText}</p>
        {link &&
          (internalLink ? (
            <CustomLink href={link}>
              <a className="theme-text font-semi" aria-label={'View All'}>
                {'View All'}
              </a>
            </CustomLink>
          ) : (
            <a href={link} className="theme-text font-semi" aria-label={'View All'}>
              {'View All'}
            </a>
          ))}
      </div>
    </div>
  )
}

WidgetCardHeader.propTypes = {
  headerText: PropTypes.string.isRequired,
  link: PropTypes.string,
  internalLink: PropTypes.bool
}

export default WidgetCardHeader
